module.exports = __webpack_public_path__ + "img/9.4aa827c.jpg";